import React from 'react';
import { FeedPost } from '../../../types/feed';
import FeedPostCard from '../FeedPostCard';
import './FeedList.css';

interface FeedListProps {
  posts: FeedPost[];
  currentUserId?: string;
  onLike?: (postId: string) => void;
  onComment?: (postId: string) => void;
  onShare?: (postId: string) => void;
  onEdit?: (postId: string) => void;
  onDelete?: (postId: string) => void;
}

const FeedList: React.FC<FeedListProps> = ({
  posts,
  currentUserId,
  onLike,
  onComment,
  onShare,
  onEdit,
  onDelete,
}) => {
  if (posts.length === 0) {
    return (
      <div className="v2-feed-list__empty">
        <p>No posts yet. Share your first adventure!</p>
      </div>
    );
  }

  return (
    <div className="v2-feed-list" role="feed" aria-label="Travel feed">
      {posts.map((post) => (
        <FeedPostCard
          key={post.id}
          post={post}
          currentUserId={currentUserId}
          onLike={onLike}
          onComment={onComment}
          onShare={onShare}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};

export default FeedList;
